import {
  AxiosError,
  AxiosHeaders,
  AxiosInstance,
  AxiosResponse,
  CustomParamsSerializer,
  InternalAxiosRequestConfig,
  ParamsSerializerOptions,
  ResponseType,
} from 'axios';

export enum APIRequestMethods {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  PUT = 'put',
  DELETE = 'delete',
}

export interface APIErrorInterface {
  success: boolean;
  timestamp: string;
  error: {
    message: string;
  };
  code: number;
  status: string;
  message: string;
}

export interface BaseHTTPClientConstructorInterface {
  baseURL: string;
  timeout?: number;
  headers?: Record<string, string>;
}

export interface AxiosClientConstructorInterface {
  HTTPClientParams: BaseHTTPClientConstructorInterface;
  isProtected: boolean;
}

export interface RequestInterceptorMiddlewareInterface {
  (requestConfig: InternalAxiosRequestConfig): InternalAxiosRequestConfig;
}

export interface ResponseInterceptorMiddlewareInterface {
  (response: AxiosResponse): AxiosResponse;
}

export interface ErrorInterceptorMiddlewareInterface {
  (error: AxiosError<APIErrorInterface | string>): Promise<never>;
}

export interface InitiateNetworkInstanceInterface {
  (params: { baseURL: string; isProtected: boolean }): AxiosInstance;
}

export interface APIServiceRequestParamsInterface {
  [key: string]:
    | string
    | number
    | Date
    | Array<string>
    | boolean
    | null
    | undefined
    | Record<string, any>;
}

export interface APIServiceRequestDataInterface {
  [key: string]: unknown;
}

export interface APIServiceRequestMethodPropsInterface {
  path: string;
  data?: APIServiceRequestDataInterface;
  params?: APIServiceRequestParamsInterface;
  paramsSerializer?: ParamsSerializerOptions | CustomParamsSerializer;
  headers?: Partial<AxiosHeaders>;
  responseType?: ResponseType;
  isProtected?: boolean;
}

export interface APIServiceRequestMethodInterface {
  <APIResponseInterface>(props: APIServiceRequestMethodPropsInterface): Promise<
    AxiosResponse<APIResponseInterface>
  >;
}

export interface APIServiceRequestPropsInterface
  extends APIServiceRequestMethodPropsInterface {
  method: APIRequestMethods;
}

export interface APIServiceRequestInterface {
  <APIResponseInterface>(props: APIServiceRequestPropsInterface): Promise<
    AxiosResponse<APIResponseInterface>
  >;
}
